export default {
  'en-US': {
    'shared-button': {
      'back-link': 'Back',
      'next-button': 'Next',
      'previous-button': 'Previous',
      'save-button': 'Save',
      'logout-button': 'Logout',
      'contact-us-link': 'Contact Us'
    },
    header: {
      'home-link': 'Home',
      'educators-link': 'EDUCATORS',
      'parents-link': 'PARENTS',
      'students-link': 'STUDENTS',
      'pricing-link': 'PRICING',
      'contact-link': 'CONTACT',
      'sign-up-link': 'Sign Up',
      'sign-in-button': 'Sign In'
    },
    footer: {
      copyright: 'Copyright© 2023 TutorD™. All rights reserved.',
      'consent-preferences': 'Consent Preferences',
      'consent-preferences-link': 'Consent Preferences'
    },
    'shared-aside': {
      title: 'TutorD',
      'dashboard-link': 'Dashboard',
      'students-link': 'Students',
      'question-sets-link': 'Question Sets',
      'classes-link': 'Classes',
      'logout-button': 'Logout',
      settings: {
        title: 'Settings',
        'profile-link': 'Profile',
        'billing-link': 'Billing',
        'organizations-link': 'Organizations'
      }
    },
    'why-tutorD': {
      title: 'Why TutorD?',
      subTitle: 'Lets talk about it, do you know if your students are engaged? Barely hanging on? Or disappeared from their learning experience?',
      'about-us-link': 'About Us'
    },
    'join-beta': {
      title: 'Don’t let your students become ',
      'statistic-link': 'Another Statistic',
      description: 'Students self identifying their learning language can provide educators with the information to make for a more engaging experience'
    },
    'QR-code': {
      title: 'Scan QR Code',
      description: 'Instructor {teacherName} invites you to their {className}',
      descriptionHelper: 'Or enter the link manually',
      'copy-button': 'Copy'
    },
    landing: {
      hero: {
        title: 'A learning experience at any distance',
        description: 'Closing the technology gap in education via SMS, TutorD takes a unique approach to individualized learning, enabling scholars to explore course curriculum, and reinforce knowledge.',
        'get-started-link': 'GET STARTED'
      },
      main: {
        title: 'Why TutorD?',
        descriptionOne: 'TutorD is an EdTech platform for Teachers and Tutors to enable distance learning with accessibility first in mind. We provide personalization by student learning styles and help track engagement and progress.',
        descriptionTwo: ' Educators can use scholar profiles and engagement feedback to develop curriculum and effectively teach their curriculum. Reporting and analytics will provide educators with data to make more informed decisions before major exams and standardized tests.',
        'join-now-button': 'Join Now'
      },
      education: {
        title: 'Where education encompasses the ',
        'title-link': 'Whole Student',
        description: 'Our mission is to provide accessibility first, using the technologies at hand.',
        subTitleOne: 'A NEW APPROACH',
        descriptionOne: 'Supported in classroom materials, teaching, and learning',
        subTitleTwo: 'MOBILE FRIENDLY',
        descriptionTwo: 'Adapted text message based platform designed to provide',
        subTitleThree: 'PRACTICE LEARNING',
        descriptionThree: 'An opportunity for Educators and Students discovery and learning via a very familiar tool'
      },
      how: {
        label: 'How does it work?',
        'enroll-card': {
          title: '1. ENROLL',
          description: 'Set Up dispatch intervals, where students will receive up to 15 questions daily or weekly.'
        },
        'cohort-card': {
          title: '2. COHORTS',
          description: 'Organize subjects into cohorts of students'
        },
        'questions-card': {
          title: '3. QUESTIONS',
          description: 'Create Question Sets or Download question sets from other educators who use our platform.'
        },
        'intervals-card': {
          title: '4. INTERVALS',
          description: 'Set Up dispatch intervals, where students will receive up to 15 questions daily or weekly.'
        },
        'progress-card': {
          title: '5. PROGRESS',
          description: 'Review students progress through data based on their engagement with the question sets, overall usage, and improvement.'
        }
      },
      benefits: {
        label: 'Benefits',
        subTitleOne: 'A tool for Educators to keep track of student progress.',
        descriptionOne: 'We at TutorD have a philosophy of fast positive feedback loops, with as little noise as possible. We measure any and all levels of student engagement; with this approach educators can really pinpoint a disconnect in the learning experience.',
        subTitleTwo: 'Achieving a higher level of understanding through practice.',
        descriptionTwo: 'By reducing the tech toolchain to the bare minimum we aim to provide a low barrier of entry for student engagement. Couple that with allowing students to self identify how they think they learn, provides the tools and insights to accelerate and increase active engagement.'
      },
      demo: {
        title: 'Schedule a Demo',
        descriptionOne: 'Please contact us at ',
        'email-link': 'admin@tutord.io',
        descriptionTwo: 'for demos.'
      },
      'learning-styles': {
        label: 'LEARNING PREFERENCE',
        title: 'Students Self Identify their Learning Styles',
        description: ' We allow Students a space to add their insight to how they perceive information and how they best learn. With that an Educator can tailor a learning experience that best supports their students.',
        auditory: 'Auditory',
        visual: 'Visual',
        handsOn: 'Hands On',
        textReading: 'Text/Reading',
        notSure: 'I\'m not sure',
        'learn-your-students-button': 'Learn Your Students'
      }
    },
    'sign-in': {
      aside: {
        title: 'Sign In',
        subTitle: 'Expanding the Learning Experience, Focused on the whole student ensuring accessibility for all.'
      },
      main: {
        signInWithGoogle: 'Sign in with Google',
        signInWithEmail: 'Or Sign in With Email',
        email: 'Email',
        password: 'Password',
        signUpHelper: 'No account?  Sign Up ',
        'sign-up-here-link': 'here.',
        'sign-in-button': 'Sign In'
      }
    },
    'sign-up': {
      aside: {
        subTitle: 'Sign Up',
        description: 'Expanding the Learning Experience, Focused on the whole student ensuring accessibility for all.'
      },
      main: {
        signUpWithGoogle: 'Sign Up with Google',
        signUpWithEmail: 'Or Sign Up With Email',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        school: 'School',
        schoolHelper: 'School/Tutor Center Name',
        password: 'Password',
        'sign-in-helper': 'Already have an account?  Sign In',
        'sign-in-link': 'here',
        conditionsHelper: 'By clicking Sign Up, you agree to our ',
        'conditions-link': 'Terms and Conditions,',
        'policy-link': 'Privacy Policy,',
        'acceptable-use-link': 'Acceptable Use Policy, ',
        and: 'and',
        'cookies-link': 'Cookies Policy. ',
        sms: 'You may receive SMS Notifications from us and can opt out any time by sending "Opt out".',
        'sign-up-button': 'Sign Up',
        learnMoreHelper: 'By selecting this box you want to learn more about what we are doing to make an impact in the learning experience and our communities via our',
        newsletter: 'Newsletter'
      }
    },
    'verify-email-sent': {
      main: {
        title: 'Verification Email Sent',
        subTitle: 'Please check your email and click on the link provided.',
        email: 'Email',
        'resend-button': 'Resend',
        verifyingEmail: 'Verify Email..'
      },
      aside: {
        title: 'Verify Email',
        subTitle: 'We\'re Here to Change the Game...' +
          'TutorD will allow you to reach your students; no accessibility or connectivity gap, we meet students where they are!'
      }
    },
    enrollment: {
      'set-student-phone-number': {
        aside: {
          title: 'TutorD',
          welcome: 'Welcome, {Student}',
          subTitle: '{Instructor } invites you to enroll in their class.'
        },
        main: {
          title: 'Please enter your phone number',
          subTitle: 'Please check your phone for an SMS with the code',
          firstName: 'First Name',
          lastName: 'Last Name',
          password: 'Password',
          'sign-in-link': 'Already have an account?  Sign In here!',
          'sign-up-button': 'Sign Up'
        }
      },
      'verify-student-phone-number': {
        aside: {
          title: 'Verify',
          welcome: 'We want to change the game...',
          subTitle: 'TutorD is a game changer and will allow you to do this and that and do we have copy for this?'
        },
        main: {
          title: 'Number verification',
          subTitle: 'Please check your phone for an SMS with the code'
        }
      },
      0: {
        aside: {
          title: 'TutorD',
          welcome: 'Welcome, {Student}',
          subTitle: '{Instructor} invites you to join their {ClassName} class.'
        },
        main: {
          title: 'Please enter your phone number',
          subTitle: 'Please check your phone for an SMS with the code',
          firstName: 'First Name',
          lastName: 'Last Name',
          password: 'Password',
          'sign-in-link': 'Already have an account?  Sign In here!',
          'sign-up-button': 'Sign Up'
        }
      },
      1: {
        aside: {
          title: 'Verify',
          welcome: 'We want to change the game...',
          subTitle: 'TutorD is a game changer and will allow you to do this and that and do we have copy for this?'
        },
        main: {
          title: 'Number verification',
          subTitle: 'Please check your phone for an SMS with the code'
        }
      },
      2: {
        aside: {
          title: 'How do you learn?',
          welcome: 'Customize your experience',
          subTitle: 'TutorD gives you access to plenty of tests, question sets and materials from our teacher working on the same subjects as you.'
        },
        main: {
          title: 'What type of learner are you?',
          subTitle: 'We are all different and we learn better in different ways - do you know what works best for you? Don’t worry if you don’t, we’ll help you find out throughout this journey.'
        }
      },
      3: {
        aside: {
          title: 'All good!',
          welcome: 'Customize your experience',
          subTitle:
            'TutorD gives you access to plenty of tests, question sets and materials from our teacher working on the same subjects as you.'
        },
        main: {
          title: 'Get ready for your first test!',
          subTitle: 'We can set up your classes and students so that you don’t have to do it manually, you will still be able to edit them afterwards.'
        }
      }
    },
    'educator-on-boarding': {
      0: {
        aside: {
          title: 'Classes',
          subTitle: 'Customize your experience',
          description: 'TutorD gives you access to plenty of test, question sets and materials from our teacher working on',
          img: '../assets/onboarding/onboarding-classes.svg'
        },
        main: {
          title: 'What courses do you teach?',
          classField: 'Add your classes',
          'add-class-button': '+ Class',
          'next-button': 'Next'
        }
      },
      'wizard-nav': {
        classes: 'Classes',
        Enrollments: 'Enrollments',
        goals: 'Goals'
      },
      1: {
        aside: {
          title: 'Enrollments',
          subTitle: 'Customize your experience',
          description: 'TutorD gives you access to plenty of tests, question sets and materials from our teachers',
          img: '../assets/enrollment/enrollment-learning-style.svg'
        },
        main: {
          title: 'Enroll your students!',
          subTitle: 'Please select from our suggestions:'
        }
      },
      2: {
        aside: {
          title: 'Goals',
          subTitle: 'We want to change the game...',
          description: 'TutorD is a game changer and will allow you to do this and that and do we have some copy for this?'
        },
        main: {
          title: 'What do you want to achieve?',
          subTitle: 'Please select all that apply.',
          titleTwo: 'How many students do you teach?'
        }
      }
    },
    'student-registration': {
      'register-student-with': {
        aside: {
          title: 'TutorD',
          subTitle: '{Instructor} invites you to enroll in their class.'
        }
      },
      'register-student-using-org-token': {
        aside: {
          subTitle: 'You have been invited to {Organization}'
        }
      }
    },
    'admin-dashboard': {
      main: {
        title: 'Welcome Back,',
        progressMessage: 'Your students completed {percentage}% of the tasks. Progress is {progressLevel}',
        progressLevel: {
          good: 'good!',
          average: 'average!',
          veryGood: 'very good!',
          excellent: 'excellent!'
        }
      }
    },
    'teacher-dashboard': {
      main: {
        title: 'Performance',
        newStudent: '+ New Student',
        'engagement-tab': 'Engagement',
        'student-trends-tab': 'Student Trends',
        'learning-styles-tab': 'Learning Styles',
        'my-students-tab': 'My Students',
        'all-classes-tab': 'All Classes',
        searchPlaceholder: 'Search Students',
        'empty-state': {
          noStudents: 'Sorry, you don\'t have any students!',
          addStudents: 'Please add the first student',
          searchedName: 'Sorry, the student with the searched name wasn`t found!',
          noQuestions: 'Sorry, you don\'t have any question sets!',
          noClasses: 'Sorry, you don\'t have any classes',
          noStudentStyle: 'Sorry, there are no students with chosen learning style',
          noGroupStyle: 'Sorry, in this tutor group no students with chosen learning style',
          noClassStyle: 'Sorry, in this class no students with chosen learning style'
        },
        recent: {
          title: 'Recent',
          questionSets: 'My Recent Question Sets',
          myClasses: 'My Classes'
        }
      }
    },
    'student-dashboard': {
      main: {
        title: 'Students',
        'new-student-button': '+ New Student',
        'invite-students-button': 'Invite Students',
        searchBar: 'Search the Students'
      },
      drawer: {
        title: 'Add Student',
        firstName: 'First Name',
        firstNamePlaceholder: 'First Name*',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Last Name*',
        email: 'Email Address',
        emailPlaceholder: 'student@institution.edu*',
        classEmail: 'Class Enrollment',
        classEmailPlaceholder: 'Choose the Classes',
        'send-invitation-button': 'Send Invitation'
      },
      'empty-state': {
        noStudents: 'Sorry, you don\'t have any students!',
        addStudent: 'Please add the first student',
        notFound: 'Sorry, the student with the searched name wasn\'t found!'
      }
    },
    'edit-student-profile': {
      main: {
        verification: {
          emailVerified: 'Email Verified',
          phoneVerified: 'Phone Verified',
          onboarded: 'Onboarded',
          email: 'Email Address'
        },
        'learner-styles': {
          title: 'Learner Type',
          textReading: 'Text/Reading',
          auditory: 'Auditory',
          visual: 'Visual',
          handsOn: 'Hands On',
          doNotKnow: 'I Do not Know'
        },
        'progress-section': {
          title: '{firsName} progress',
          allTutors: 'All Tutors',
          allSessions: 'All Sessions',
          groupSessions: 'Group Session',
          compareTo: 'Compare To',
          timeline: 'Timeline',
          comparison: 'Comparison',
          'student-button': 'Student',
          'group-average-button': 'Group Average'
        },
        'student-dialogue': {
          title: 'Student Dialogue',
          justNow: 'Just Now',
          yesterday: 'Yesterday at '
        }
      }
    },
    'question-set-dashboard': {
      main: {
        title: 'Question Sets',
        'create-new-set-button': '+ Create New Set',
        newQuestionSet: 'New Question Set',
        difficulty: 'Difficulty',
        searchPlaceholder: 'Search the Question Sets'
      },
      'empty-state': {
        notFound: 'Sorry, the question set with the searched name wasn\'t found!',
        noQuestions: 'Sorry, you don\'t have any question sets!',
        addQuestion: 'Please add the first question set'
      }
    },
    'edit-question-set-dashboard': {
      main: {
        title: '{questionSetName}',
        questionsAdded: '{questions} questions added',
        'done-button': 'Done',
        'add-question-button': 'Question',
        'delete-question-set-button': 'Delete Question Set',
        questionTitle: 'Question',
        questionPlaceholder: 'What is a molecule?',
        format: {
          format: 'Format',
          'multiple-choice': 'Multiple Choice',
          'true-false': 'True or False'
        },
        difficulty: 'Difficulty',
        'show-answers-button': 'Show Answers',
        'hide-answers-button': 'Hide Answers',
        'add-hint-button': '+Add Hint',
        'add-answer-button': 'Add Answer',
        hintTitle: 'Hint',
        hintPlaceholder: 'Select Hint Type',
        learnerType: 'ALL',
        learnerTypeTitle: 'Learner Type',
        answerTitle: 'Answer',
        enterAnswer: 'Enter Answer Here...',
        errorState: 'Please add question'
      }
    },
    'classes-dashboard': {
      main: {
        title: 'Classes',
        'create-class-button': '+Create Class',
        searchBar: 'Search the Classes',
        classCard: {
          className: 'Class Name',
          'edit-button': 'Edit',
          'delete-button': 'Delete'
        }
      },
      emptyState: {
        notFound: 'Sorry, the class with the searched name wasn\'t found!',
        noClasses: 'Sorry, you don\'t have any classes!',
        addClass: 'Please add the first class!',
        noStudents: 'Sorry, no students in this class!',
        addStudent: 'Please add the first student to this class!',
        noStudentToAdd: 'Sorry, you don\'t have any students to add to this class'
      },
      drawer0: {
        title: 'Class Name',
        classNamePlaceholder: 'New Class Name',
        enrolledStudents: 'Enrolled Students',
        description: 'Students Enrolled',
        descriptionHelper: 'Please add students to the class',
        'add-student-button': 'ADD STUDENTS +',
        'add-remove-student-button': '+/- STUDENTS',
        'submit-button': 'Submit'
      },
      drawer1: {
        studentEnrollments: 'Student Enrollments',
        currentClassEnrollments: 'Current Class Enrollments',
        studentsEnrolled: 'Students Enrolled',
        allStudents: 'All Students',
        availableStudents: 'Available Students'
      }
    },
    'edit-class-dashboard': {
      main: {
        'add-remove-student-button': '+/- STUDENTS',
        'add-student-button': 'ADD STUDENTS +',
        'engagement-tab': 'Engagement',
        'group-trends-tab': 'Group Trends',
        'student-trends-tab': 'Student Trends',
        'learning-styles-tab': 'Learning Styles',
        'missed-legend': ' Missed',
        'correct-legend': 'Correct',
        'my-students-tab': 'My Students',
        'group-management': {
          title: '{Class Name}',
          'show-qr-code-button': 'Show QR Code',
          'new-tutor-group-button': 'NEW TUTOR GROUP',
          'students-subTitle': 'Students',
          allGroups: 'All Groups',
          activeSession: 'Active Session',
          completedSession: 'Completed Session',
          tutorGroups: 'Tutor Groups',
          'save-button': 'SAVE'
        },
        'learning-styles': {
          visual: 'Visual',
          handsOn: 'Hands On',
          reading: 'Reading',
          notSure: 'Not Sure'
        }
      },
      drawer: {
        title: 'Current Class Students',
        studentsAdded: '{totalStudents} Students Added',
        allStudents: 'All Students',
        students: 'Students'
      },
      emptyState: {
        notActiveSession: 'Sorry, no tutor groups with the active sessions in this class !',
        noCompletedSession: 'Sorry, no tutor groups with the completed sessions in this class !',
        noGroup: 'Sorry, no tutor groups in this class!',
        addGroup: 'Please add the first tutor group to this class',
        addStudents: 'Please add students to this class',
        noStudents: 'Sorry, no students in this class !',
        noStudentToAdd: 'Sorry, you don\'t have any students to add to this class'
      },
      errorState: 'Class Error',
      deleteState: {
        'delete-class-button': 'Delete Class',
        delete: 'Do you want to delete {class}?',
        deleteContent: 'All Classes, Tutor Groups, Session and Student data will be deleted if you do delete '
      }
    },
    'tutor-group': {
      main: {
        difficulty: 'Difficulty',
        'create-button': 'Create',
        'create-group': {
          title: 'Create Tutor Group',
          groupName: 'Group Name',
          newGroup: 'New Tutor Group'
        },
        'edit-group': {
          title: 'Edit Tutor Group',
          groupName: 'Group Name',
          defaultGroup: 'Default Tutor Group',
          'engagement-tab': 'Engagement',
          'student-trends-tab': 'Student Trends',
          'learning-styles-tab': 'Learning Styles',
          'delete-group-button': 'Delete Group'
        },
        'student-management': {
          title: 'Students',
          description: 'Please add students to the tutor group',
          'add-student-button': 'ADD STUDENTS +',
          'add-remove-student-button': '+/- STUDENTS'
        },
        'question-management': {
          title: 'Question Sets',
          'add-question-set-button': 'ADD QUESTION SETS +',
          'add-remove-question-button': '+/- QUESTION SETS'
        },
        dispatchInterval: {
          title: 'Dispatch Interval:',
          'day-label': 'Day',
          everyday: 'Everyday',
          'time-label': 'Time',
          immediate: 'Immediate',
          'interval-label': 'Interval',
          'per-week-label': '1 Question Per Week',
          'per-day-label': '1 Question Per Day',
          'per-hour-label': '1 Question Per Hour',
          'per-minute-label': '1 Question Per Minute'
        }
      },
      'question-sets-drawer': {
        title: 'Question Sets',
        subTitle: 'Tutor Group Question Sets',
        totalQuestionsAdded: '{total} Questions Sets added',
        myQuestionSets: 'My Question Sets',
        questionSetsAvailable: '{total} Questions Sets available'
      },
      'students-drawer': {
        currentGroupEnrollment: 'Current Tutor Group Enrollment',
        totalStudentsAdded: '{total} Students added',
        totalStudents: '{total} Students',
        currentClassEnrollment: 'Current Class Enrollment'
      },
      emptyState: {
        noQuestions: 'Sorry, no question sets in this Tutor Group.',
        noStudents: 'Sorry, no students in this Tutor Group.',
        noStudentsToAdd: 'Sorry, you don\'t have any students to add to this tutor group',
        addQuestions: 'Please add the first question set to this Tutor Group!',
        addStudents: 'Please add the first student to this Tutor Group!',
        noQuestionSets: 'Sorry, you don\'t have any available question sets to add to this tutor group'
      }
    },
    profile: {
      main: {
        title: 'My Profile',
        emailVerified: 'Email verified',
        onboarded: 'Onboarded',
        'share-button': 'SHARE',
        'delete-account-button': 'Delete Account',
        'save-button': 'Save',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        password: 'Password',
        'learning-styles': {
          title: 'Manage Learner Types',
          addLearnerStyle: 'Add Learner Style',
          visual: 'Visual',
          handsOn: 'Hands On',
          reading: 'Text/Reading',
          auditory: 'Auditory',
          publicProfile: 'Public Profile',
          profileHelper: '(This will allow other teachers to see your question sets)'
        },
        'cookie-link': 'Do not sell or share my personal information',
        'personal-data-link': 'Limit the use of my sensitive personal information'
      },
      'edit-profile': {
        editProfile: 'Edit Profile Picture',
        click: 'Click to edit',
        selectImage: 'Please select an image first',
        'cancel-button': 'Cancel',
        'confirm-button': 'Confirm'
      }
    },
    billing: {
      main: {
        'current-bill': {
          label: 'Current Yearly Bill',
          'switch-monthly-link': 'Switch to monthly billing',
          'switch-yearly-link': 'Switch to monthly billing'
        },
        'next-payment': {
          label: 'Next payment due',
          'view-payment-history-link': 'View payment history'
        },
        'payment-info': {
          label: 'Payment information',
          'update-payment-link': 'Update payment method',
          'share-scholarship-link': 'Share with scholarship provider',
          'redeem-coupon-link': 'Redeem coupon'
        },
        'current-plan': {
          title: 'CURRENT PLAN',
          'edit-button': 'Edit'
        }
      }
    },
    'billing-history': {
      main: {
        title: 'Transaction History',
        'previous-button': 'Previous',
        'next-button': 'Next',
        columns: {
          customerName: 'Customer Name',
          customerEmail: 'Customer Email',
          effectiveDate: 'Effective Date',
          status: 'Status',
          totalExcludingTax: 'Total Excluding Tax ($)',
          subtotal: 'Subtotal ($)',
          total: 'Total ($)',
          invoiceUrl: 'Hosted Invoice URL'
        }
      },
      emptyState: {
        'no-data-message': 'No Data'
      }
    },
    organizations: {
      main: {
        title: 'Organizations',
        owner: 'Owner',
        'settings-button': 'Settings',
        'leave-button': 'Leave',
        'new-organization-button': 'New Organization',
        transformAccounts: 'Transform Accounts',
        'turn-tutorB-button': 'Turn theTutorB into an organization'
      }
    },
    'organization-plans': {
      main: {
        title: 'Pick a plan for your organization',
        subTitle: 'Choose A Plan',
        price: '{price}/month',
        getStarted: 'GET STARTED',
        includes: 'Includes',
        month: 'Month',
        annual: 'Annual',
        'basic-card': {
          label: 'BASIC',
          description: 'TutorD Basic product plan. Single seater organization plan 1 educator who can manage up to 150 active learners.'
        },
        'team-card': {
          label: 'TEAM PLUS',
          description: 'TutorD Team Plus product plan. Unlimited Educators and Admins, organization plan, manage up to 1k active students with unlimited messages.'
        }
      }
    },
    'organization-payment': {
      main: {
        title: 'Payment Details Page',
        paymentDetails: 'Payment Details',
        monthlySubscription: 'Monthly Subscription',
        yearlySubscription: 'Yearly Subscription',
        payMonthly: 'Pay Monthly',
        payYearly: 'Pay Yearly',
        plan: 'PLAN',
        price: 'PRICE',
        total: 'TOTAL',
        firstName: 'First Name',
        firstNamePlaceholder: 'First Name*',
        lastName: 'Last Name',
        lastNamePlaceholder: 'Last Name*',
        billingEmail: 'Billing Email',
        billingEmailPlaceholder: 'Billing Email',
        promoCode: 'Promo Code',
        promoCodePlaceholder: 'Promo Code2024!',
        cardNumber: 'Card Number',
        'save-payment-button': 'Save Payment Method'
      }
    },
    'organization-setup': {
      main: {
        title: 'Setup your organization ',
        subTitle: 'Tell us about your organization ',
        orgAccountName: 'Organization Account Name',
        orgAccountNamePlaceholder: 'Account Name*',
        belongsTo: 'This organization belongs to: ',
        personalAccount: ' My personal account',
        businessAccount: 'A business or institution',
        'next-payment-button': 'Next Payment Details'
      }
    },
    'educators-header': {
      main: {
        descriptionOne: 'We provide products that increase engagement between student and teacher in a safe and trackable way. TutorD also increases engagement based on the communication methods utilized to facilitate interactions between students and class content.',
        descriptionTwo: 'We meet the students where they are, and deliver the entire curriculum via mobile phone to keep your students engaged if they don\'t have access to a computer.',
        'private-beta': {
          title: 'Join our Private Beta',
          subTitle: 'We are looking for teachers interested in going on the journey with us, limited spaces available.',
          'demo-button': 'Schedule Demo'
        }
      }
    },
    'students-header': {
      main: {
        description: 'Studies show that 95% of Americans have a cell phone. Some don’t have internet at home, some don\'t have multiple computers at home, others don\'t have the emotional strength to get to their computer. We meet our scholars on their cell phones.'
      }
    },
    'students-join-beta': {
      title: 'Lets be smart about education ',
      'smartphone-link': 'Everyone Has A Smartphone.',
      description: 'Students live on their phones and meeting them with engaging curriculum via the platform they are most familiar with is critical to keeping students engaged.'
    },
    'parents-header': {
      main: {
        description: 'We know times are hard and this pandemic has created a lot of challenges for families. Our goal is to ease those challenges by providing easier access to your child\'s classroom and their curriculum. We would love your child\'s institution to join our journey.',
        'about-us-link': 'ABOUT US',
        'whole-student': {
          title: 'Allowing you to address the ',
          'title-link': 'Whole Student',
          description: 'Students self identifying their learning language can provide educators with the information to make for a more engaging experience.',
          subtitleOne: 'A NEW APPROACH',
          descriptionOne: 'Education always has to keep up with technology and culture - it is an evolving practice and we are taking an approach that is adaptive and engaging.',
          subtitleTwo: 'ACCESSIBLE ANYWHERE',
          descriptionTwo: 'Our approach is mobile first which gives your students the ability to engage with your educational materials anywhere, because everyone has a phone.',
          subtitleThree: 'PRACTICE LEARNING',
          descriptionThree: 'With a text message thread students can now have a study guide at hand to review and gain confidence and mastery.'
        }
      }
    },
    'pricing-header': {
      main: {
        month: 'Month',
        annual: 'Annual'
      },
      basic: {
        monthly: {
          price: '$55/Month'
        },
        annual: {
          price: '$40/Month'
        },
        label: 'BASIC',
        subTitle: 'Solo educators looking to reach more learners',
        description: 'Unlimited students, classes, curriculum and messages',
        'access-list': {
          'access-to': 'Access to',
          1: 'Unlimited data history & student seats',
          2: 'Unlimited curriculum and messages sent to learners.',
          3: 'Monitoring & reports',
          4: 'Legendary email support'
        }
      },
      team: {
        label: 'TEAM',
        subTitle: 'More answers for more people',
        description: 'Support your small organizations learning needs',
        'access-list': {
          'access-to': 'Access to',
          'all-features': 'All features in ',
          basic: 'Basic',
          1: '500 Students, with unlimited Teachers, and Admins',
          2: 'Unlimited curriculum and messages sent to learners.',
          3: 'Monitoring & reports',
          4: 'Legendary email support'
        }
      },
      'team-plus': {
        label: 'TEAM PLUS',
        subTitle: 'For larger schools and institutions',
        description: 'Unlimited everything!',
        'access-list': {
          'access-to': 'Access to',
          1: 'Unlimited saved reports & session performance',
          2: 'Impact report with causal inference',
          3: 'Data modeling',
          4: 'Group Analytics & Data Pipelines add-ons',
          5: 'Premium support with  4 hours response time'
        }
      },
      table: {
        columns: {
          basic: 'Basic',
          features: 'Features',
          team: 'Team',
          teamPlus: 'Team Plus'
        },
        rows: {
          phoneNumber: '# of Phone Number',
          12: '12',
          tutorGroups: '# of Tutor Groups',
          classes: '# of Classes',
          scholars: '# of Scholars/Classes',
          adminUsers: 'Admin Users',
          vanityNumbers: 'Vanity Numbers',
          advancedMetrics: 'Advanced Metrics',
          questionSetPriority: 'Question Set Priority',
          orgInsights: 'Org Insights',
          adminOversight: 'Admin Oversight',
          rostering: 'Roastering/SIS',
          lmsIntegration: 'LMS Integration',
          roleBasedRules: 'Role Based Access Rules',
          studentProfile: 'Student Profile',
          educatorProfile: 'Education Profile',
          publicPrivate: 'Public/Private',
          publicPrivateTeam: 'Public/Private/Team'
        }
      },
      'get-started-link': 'Get started'
    },
    'contact-header': {
      main: {
        title: 'Keep Expanding Your Reach!',
        subTitle: 'Looking to utilize our platform? want to learn more about what we are doing at TutorD? Or simply connect?',
        description: 'Please fill out our contact form and we will be sure to follow up with you, we are looking forward to seeing how we can help be of service to you or support you, or maybe you can help us out, you never know!',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        jobTitle: 'Job Title',
        phoneNumber: 'Phone Number',
        subject: 'Subject',
        messageBody: 'Message',
        message: 'Let us know a bit more about who you are and what you are interested in learning more about.',
        'send-button': 'SEND'
      }
    }
  },
  'es-ES': {
    'shared-button': {
      'back-link': '',
      'next-button': '',
      'previous-button': '',
      'save-button': 'Guardar',
      'logout-button': '',
      'contact-us-link': ''
    },
    header: {
      'home-link': '',
      'educators-link': '',
      'parents-link': '',
      'students-link': 'ESTUDIANTES',
      'pricing-link': '',
      'contact-link': '',
      'sign-up-link': '',
      'sign-in-button': ''
    },
    footer: {
      copyright: '',
      'consent-preferences': '',
      'consent-preferences-link': ''
    },
    'shared-aside': {
      title: 'TutorD',
      'dashboard-link': 'Panel de Control',
      'students-link': 'Estudiantes',
      'question-sets-link': 'Conjuntos de Preguntas',
      'classes-link': 'Clases',
      'logout-button': 'Cerrar sesión',
      settings: {
        title: 'Configuración',
        'profile-link': 'Perfil',
        'billing-link': 'Facturación',
        'organizations-link': 'Organizaciones'
      }
    },
    'why-tutorD': {
      title: '?',
      subTitle: '',
      'about-us-link': ''
    },
    'join-beta': {
      title: '',
      'statistic-link': '',
      description: ''
    },
    'QR-code': {
      title: 'Escanear código QR',
      description: 'Instrucción {teacherName} te invita a su clase de {className}.Escanear código QR.',
      descriptionHelper: 'O Ingrese el Enlace Manualmente',
      'copy-button': 'Copiar'
    },
    landing: {
      hero: {
        title: '',
        description: '',
        'get-started-link': ''
      },
      main: {
        title: '',
        descriptionOne: '',
        descriptionTwo: '',
        'join-now-button': ''
      },
      education: {
        title: '',
        'title-link': '',
        description: '',
        subTitleOne: '',
        descriptionOne: '',
        subTitleTwo: '',
        descriptionTwo: '',
        subTitleThree: '',
        descriptionThree: ''
      },
      how: {
        label: 'How does it work?',
        'enroll-card': {
          title: '1. ',
          description: ''
        },
        'cohort-card': {
          title: '2. ',
          description: ''
        },
        'questions-card': {
          title: '3. QUESTIONS',
          description: ''
        },
        'intervals-card': {
          title: '4. ',
          description: ''
        },
        'progress-card': {
          title: '5. ',
          description: ''
        }
      },
      benefits: {
        label: '',
        subTitleOne: '',
        descriptionOne: '',
        subTitleTwo: '',
        descriptionTwo: ''
      },
      demo: {
        title: '',
        descriptionOne: '',
        'email-link': 'admin@tutord.io',
        descriptionTwo: ''
      },
      'learning-styles': {
        label: '',
        title: '',
        description: '',
        auditory: 'Auditivo',
        visual: 'Visual',
        handsOn: 'Manos a la obra',
        textReading: 'Texto/Lectura',
        notSure: '',
        'learn-your-students-button': ''
      }
    },
    // landing: {
    //   title: '¡Bienvenido a TutorD!',
    //   description: 'Expandiendo la Experiencia de Aprendizaje, enfocado en la totalidad del estudiante asegurando la accesibilidad para todos.',
    //   'sign-in-button': 'Registrarse',
    //   'sign-up-link': 'Regístrate'
    // },
    'sign-in': {
      title: 'Registrarse',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      'sign-up-link': '¿No tienes cuenta? ¡Registrate aquí!',
      'sign-in-button': 'Registrarse'
    },
    'sign-up': {
      aside: {
        subTitle: 'Regístrate',
        description: ''
      },
      main: {
        signUpWithGoogle: 'Sign Up with Google',
        signUpWithEmail: 'Or Sign Up With Email',
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo Electrónico',
        school: '',
        schoolHelper: '',
        password: 'Contraseña',
        'sign-in-helper': '¿Ya tienes una cuenta?  ¡Firme',
        'sign-in-link': 'aquí!',
        conditionsHelper: '',
        'conditions-link': '',
        'policy-link': '',
        'acceptable-use-link': '',
        and: '',
        'cookies-link': '',
        sms: '',
        'sign-up-button': 'Regístrate',
        learnMoreHelper: '',
        newsletter: ''
      }
    },
    'verify-email-sent': {
      main: {
        title: '',
        subTitle: '',
        email: 'Correo Electrónico',
        'resend-button': '',
        verifyingEmail: ''
      },
      aside: {
        title: '',
        subTitle: '' +
          ''
      }
    },
    enrollment: {
      'set-student-phone-number': {
        aside: {
          title: 'TutorD',
          welcome: '',
          subTitle: ''
        },
        main: {
          title: '',
          subTitle: '',
          firstName: 'Nombre ',
          lastName: 'Apellido',
          password: 'Contraseña',
          'sign-in-link': '¿Ya tienes una cuenta?  ¡Firme aqui!',
          'sign-up-button': 'Regístrate'
        }
      },
      'verify-student-phone-number': {
        aside: {
          title: '',
          welcome: '',
          subTitle: ''
        },
        main: {
          title: '',
          subTitle: ''
        }
      },
      0: {
        aside: {
          title: 'TutorD',
          welcome: 'Bienvenido, {Student}',
          subTitle: '{Instructor},'
        },
        main: {
          title: '',
          subTitle: '',
          firstName: 'Nombre ',
          lastName: 'Apellido',
          password: 'Contraseña',
          'sign-in-link': '¿Ya tienes una cuenta?  ¡Firme aqui!',
          'sign-up-button': 'Regístrate'
        }
      },
      1: {
        aside: {
          title: '',
          welcome: '',
          subTitle: ''
        },
        main: {
          title: '',
          subTitle: ''
        }
      },
      2: {
        aside: {
          title: '',
          welcome: '',
          subTitle: ''
        },
        main: {
          title: '',
          subTitle: ''
        }
      },
      3: {
        aside: {
          title: '',
          welcome: '',
          subTitle:
            ''
        },
        main: {
          title: '',
          subTitle: ''
        }
      }
    },
    'educator-on-boarding': {
      0: {
        aside: {
          title: 'Clases',
          subTitle: '',
          description: '',
          img: '../assets/onboarding/onboarding-classes.svg'
        },
        main: {
          title: '',
          classField: '',
          'add-class-button': '+ Clase',
          'next-button': ''
        }
      },
      'wizard-nav': {
        classes: 'Clases',
        Enrollments: '',
        goals: ''
      },
      1: {
        aside: {
          title: '',
          subTitle: 'C',
          description: '',
          img: '../assets/enrollment/enrollment-learning-style.svg'
        },
        main: {
          title: '',
          subTitle: ''
        }
      },
      2: {
        aside: {
          title: '',
          subTitle: '',
          description: ''
        },
        main: {
          title: '',
          subTitle: '',
          titleTwo: ''
        }
      },
      'student-registration': {
        'register-student-with': {
          aside: {
            title: 'TutorD',
            subTitle: '{Instructor} '
          }
        },
        'register-student-using-org-token': {
          aside: {
            subTitle: ' {Organization}'
          }
        }
      }
    },
    'admin-dashboard': {
      main: {
        title: 'Bienvenido de nuevo,',
        progressMessage: 'Sus estudiantes completaron el {percentage}% de las tareas. El progreso es {progressLevel}!',
        progressLevel: {
          good: 'good!',
          average: 'average!',
          veryGood: 'very good!',
          excellent: 'excellent!'
        }
      }
    },
    'teacher-dashboard': {
      main: {
        title: 'Actuación',
        newStudent: '+ New Student',
        'engagement-tab': 'Participación',
        'student-trends-tab': 'Tendencias Estudiantiles',
        'learning-styles-tab': 'Estilos de Aprendizaje',
        'my-students-tab': 'Mis Estudiantes',
        'all-classes-tab': 'Todas las Clases',
        searchPlaceholder: 'Buscar Estudiantes',
        'empty-state': {
          noStudents: '',
          addStudents: '',
          searchedName: '',
          noQuestions: '',
          noClasses: '',
          noStudentStyle: '',
          noGroupStyle: '',
          noClassStyle: ''
        },
        recent: {
          title: 'Reciente',
          questionSets: 'Mis Conjuntos de Preguntas Recientes\n',
          myClasses: 'Mis clases'
        }
      }
    },
    'student-dashboard': {
      main: {
        title: 'Estudiantes',
        'new-student-button': '+ Estudiante Nuevo',
        'invite-students-button': 'Invitar Estudiante',
        searchBar: 'Buscar Estudiantes'
      },
      drawer: {
        title: '',
        firstName: 'Nombre',
        firstNamePlaceholder: 'Nombre*',
        lastName: 'Apellido',
        lastNamePlaceholder: 'Apellido*',
        email: 'Correo electrónico',
        emailPlaceholder: '',
        classEmail: '',
        classEmailPlaceholder: '',
        'send-invitation-button': ''
      },
      'empty-state': {
        noStudents: '',
        addStudent: '',
        notFound: ''
      }
    },
    'edit-student-profile': {
      main: {
        verification: {
          emailVerified: 'Correo electrónico verificado',
          phoneVerified: 'Teléfono verificado',
          onboarded: 'Integración',
          email: 'Correo electrónico',
          'save-button': 'Guardar'
        },
        'learner-styles': {
          title: 'Tipo de alumno',
          textReading: 'Texto/Lectura',
          auditory: 'Auditivo',
          visual: 'Visual',
          handsOn: 'Manos a la obra',
          doNotKnow: 'No lo sé'
        },
        'progress-section': {
          title: '{firsName} progreso',
          allTutors: 'Todos Tutor',
          allSessions: 'Toda la Sesión',
          groupSessions: '',
          compareTo: '',
          timeline: '',
          comparison: '',
          'student-button': 'Estudiante',
          'group-average-button': 'Promedio del Grupo'
        },
        'student-dialogue': {
          title: '',
          justNow: '',
          yesterday: ''
        }
      }
    },
    'question-set-dashboard': {
      main: {
        title: 'Conjuntos de Preguntas',
        'create-new-set-button': '+ Crear Nuevo Conjunto',
        newQuestionSet: 'New Question Set',
        difficulty: 'Dificultad',
        searchPlaceholder: 'Buscar en los Conjuntos de Preguntas'
      },
      'empty-state': {
        notFound: '',
        noQuestions: '',
        addQuestion: ''
      }
    },
    'edit-question-set-dashboard': {
      main: {
        title: '{questionSetName}',
        questionsAdded: '{questions} ',
        'done-button': '¡Hecho!',
        'add-question-button': 'Pregunta',
        'delete-question-set-button': 'Eliminar conjunto de preguntas',
        questionTitle: 'Pregunta',
        questionPlaceholder: '',
        format: {
          format: 'Formato',
          'multiple-choice': 'Opción múltiple',
          'true-false': 'Verdadero o Falso'
        },
        difficulty: 'Dificultad',
        'show-answers-button': 'Mostrar Respuestas',
        'hide-answers-button': 'Ocultar respuestas',
        'add-hint-button': '+Añadir pista',
        'add-answer-button': 'Añadir Respuesta',
        hintTitle: 'Pistas',
        hintPlaceholder: '',
        learnerType: '',
        learnerTypeTitle: 'Pista de Tipo de alumno',
        answerTitle: 'Respuesta',
        enterAnswer: '',
        errorState: ''
      }
    },
    'classes-dashboard': {
      main: {
        title: 'Clases',
        'create-class-button': '+Crear Clase',
        searchBar: '',
        classCard: {
          className: '',
          'edit-button': 'Editar',
          'delete-button': 'Borrar'
        }
      },
      emptyState: {
        notFound: '',
        noClasses: '',
        addClass: '',
        noStudents: '',
        addStudent: '',
        noStudentToAdd: ''
      },
      drawer0: {
        title: '',
        classNamePlaceholder: '',
        enrolledStudents: '',
        description: '',
        descriptionHelper: '',
        'add-student-button': '',
        'add-remove-student-button': '+/- Estudiantes',
        'submit-button': ''
      },
      drawer1: {
        studentEnrollments: '',
        currentClassEnrollments: '',
        studentsEnrolled: '',
        allStudents: '',
        availableStudents: ''
      }
    },
    'edit-class-dashboard': {
      main: {
        'add-remove-student-button': '+/- Estudiantes',
        'add-student-button': '',
        'engagement-tab': 'Participación',
        'student-trends-tab': 'Tendencias Estudiantiles',
        'learning-styles-tab': 'Estilos de Aprendizaje',
        'missed-legend': ' Faltas',
        'correct-legend': 'Corregir',
        'my-students-tab': 'Mis Estudiantes',
        'group-management': {
          title: '{Class Name}',
          'show-qr-code-button': 'Mostrar Código QR',
          'new-tutor-group-button': 'NUEVO GRUPO DE TUTOR',
          'students-subTitle': 'Estudiantes',
          allGroups: 'Todos los Grupos',
          activeSession: '',
          completedSession: '',
          tutorGroups: 'Grupos de Tutor',
          'save-button': 'GURDAR'
        },
        'learning-styles': {
          visual: 'Visual',
          handsOn: 'Manos a la Obra',
          reading: 'Lectura',
          notSure: 'Indeciso'
        }
      },
      drawer: {
        title: '',
        studentsAdded: '{totalStudents} =',
        allStudents: '',
        students: 'Estudiantes'
      },
      emptyState: {
        notActiveSession: '',
        noCompletedSession: '',
        noGroup: '',
        addGroup: '',
        addStudents: '',
        noStudents: '',
        noStudentToAdd: ''
      },
      errorState: '',
      deleteState: {
        'delete-class-button': '',
        delete: '',
        deleteContent: ''
      }
    },
    main: {
      title: 'Crear Grupo de Tutor',
      difficulty: 'Difficultad',
      'create-button': 'Crear',
      'group-management': {
        title: 'Nombre de Grupo',
        newGroup: ''
      },
      'student-management': {
        title: 'Estudiantes',
        description: 'Por favor Agregue Estudiantes al Grupo deTutor',
        'add-student-button': 'Añadir Estudiantes +',
        'add-remove-student-button': '+/- Estudiantes'
      },
      'question-management': {
        title: 'Conjuntos de Preguntas',
        'add-question-set-button': 'AÑADIR CONJUNTOS DE PREGUNTAS +',
        'add-remove-question-button': '+/- CONJUNTOS DE PREGUNTAS'
      },
      dispatchInterval: {
        title: 'Intervalo de despacho:',
        'day-label': 'Día',
        everyday: 'Todos los Días',
        'time-label': 'Hora',
        immediate: 'Inmediato',
        'interval-label': 'Intervalo',
        'per-week-label': '1 Pregunta por Semana',
        'per-day-label': '1 Pregunta por Día',
        'per-hour-label': '1 QPregunta porr Hora',
        'per-minute-label': '1 Pregunta por Minuto'
      }
    },
    'question-sets-drawer': {
      title: '',
      totalQuestionsAdded: '{total} ',
      questionSetsAvailable: '{total} '
    },
    'students-drawer': {
      currentGroupEnrollment: '',
      totalStudentsAdded: '{total} ',
      totalStudents: '{total} Estudiantes',
      currentClassEnrollment: ''
    },
    emptyState: {
      noQuestions: '',
      noStudents: '',
      noStudentsToAdd: '',
      addQuestions: '',
      addStudents: '',
      noQuestionSets: ''
    }
  },
  profile: {
    main: {
      title: 'Mi Perfil',
      emailVerified: 'Correo Electrónico Verificado',
      onboarded: 'Incorporado',
      'share-button': 'SHARE',
      'delete-account-button': 'Eliminar cuenta',
      'save-button': 'Save',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      password: 'Contraseña',
      'learning-styles': {
        title: 'Administrar Tipos de Estudiantes',
        addLearnerStyle: 'Añadir tipo de estudiante',
        visual: 'Visual',
        handsOn: 'Manos a la Obra',
        reading: 'Texto/Lectura',
        auditory: 'Auditivo',
        publicProfile: 'Perfil público',
        profileHelper: '(Esto permitirá que otros profesores vean tus preguntas y tu currículo)'
      },
      'cookie-link': 'No vender ni compartir mi información personal',
      'personal-data-link': 'Limitar el uso de mi información personal confidencia'
    },
    'edit-profile': {
      editProfile: '',
      click: '',
      selectImage: '',
      'cancel-button': '',
      'confirm-button': ''
    }
  },
  billing: {
    main: {
      'current-bill': {
        label: '',
        'switch-monthly-link': '',
        'switch-yearly-link': ''
      },
      'next-payment': {
        label: '',
        'view-payment-history-link': ''
      },
      'payment-info': {
        label: '',
        'update-payment-link': '',
        'share-scholarship-link': '',
        'redeem-coupon-link': ''
      },
      'current-plan': {
        title: '',
        'edit-button': ''
      }
    }
  },
  'billing-history': {
    main: {
      title: '',
      'previous-button': '',
      'next-button': '',
      columns: {
        customerName: '',
        customerEmail: '',
        effectiveDate: '',
        status: '',
        totalExcludingTax: '',
        subtotal: '',
        total: '',
        invoiceUrl: ''
      }
    },
    emptyState: {
      'no-data-message': ''
    }
  },
  organizations: {
    main: {
      title: '',
      owner: '',
      'settings-button': '',
      'leave-button': '',
      'new-organization-button': '',
      transformAccounts: '',
      'turn-tutorB-button': ''
    }
  },
  'organization-plans': {
    main: {
      title: '',
      subTitle: '',
      price: '{price}',
      getStarted: '',
      includes: '',
      month: '',
      annual: '',
      'basic-card': {
        label: '',
        description: ''
      },
      'team-card': {
        label: '',
        description: ''
      }
    }
  },
  'organization-payment': {
    main: {
      title: '',
      paymentDetails: '',
      monthlySubscription: '',
      yearlySubscription: '',
      payMonthly: '',
      payYearly: '',
      plan: '',
      price: '',
      total: '',
      firstName: '',
      firstNamePlaceholder: '',
      lastName: '',
      lastNamePlaceholder: '',
      billingEmail: '',
      billingEmailPlaceholder: '',
      promoCode: '',
      promoCodePlaceholder: '',
      cardNumber: '',
      'save-payment-button': ''
    }
  },
  'organization-setup': {
    main: {
      title: '',
      subTitle: '',
      orgAccountName: '',
      orgAccountNamePlaceholder: '',
      belongsTo: '',
      personalAccount: '',
      businessAccount: '',
      'next-payment-button': ''
    }
  },
  'educators-header': {
    main: {
      descriptionOne: '',
      descriptionTwo: '',
      'private-beta': {
        title: '',
        subTitle: '',
        'demo-button': ''
      }
    }
  },
  'students-header': {
    main: {
      description: ''
    }
  },
  'students-join-beta': {
    title: '',
    'smartphone-link': '',
    description: ''
  },
  'parents-header': {
    main: {
      description: '',
      'about-us-link': '',
      'whole-student': {
        title: '',
        'title-link': '',
        description: '',
        subtitleOne: '',
        descriptionOne: '',
        subtitleTwo: '',
        descriptionTwo: '',
        subtitleThree: '',
        descriptionThree: ''
      }
    }
  },
  'pricing-header': {
    main: {
      month: '',
      annual: ''
    },
    basic: {
      monthly: {
        price: ''
      },
      annual: {
        price: ''
      },
      label: '',
      subTitle: '',
      description: '',
      'access-list': {
        'access-to': '',
        1: '',
        2: '',
        3: '',
        4: ''
      }
    },
    team: {
      label: '',
      subTitle: '',
      description: '',
      'access-list': {
        'access-to': '',
        'all-features': '',
        basic: '',
        1: '',
        2: '',
        3: '',
        4: ''
      }
    },
    'team-plus': {
      label: '',
      subTitle: '',
      description: '',
      'access-list': {
        'access-to': '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
      }
    },
    table: {
      columns: {
        basic: '',
        features: '',
        team: '',
        teamPlus: ''
      },
      rows: {
        phoneNumber: '',
        12: '12',
        tutorGroups: '',
        classes: '',
        scholars: '',
        adminUsers: '',
        vanityNumbers: '',
        advancedMetrics: '',
        questionSetPriority: '',
        orgInsights: '',
        adminOversight: '',
        rostering: '',
        lmsIntegration: '',
        roleBasedRules: '',
        studentProfile: '',
        educatorProfile: '',
        publicPrivate: '',
        publicPrivateTeam: ''
      }
    },
    'get-started-link': ''
  },
  'contact-header': {
    main: {
      title: '',
      subTitle: '',
      description: '',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      jobTitle: '',
      phoneNumber: '',
      subject: '',
      messageBody: '',
      message: '',
      'send-button': ''
    }
  }
};
